<template>
  <div>
    <div style="margin: 4px">
      <v-card class="mb-12">
        <v-card-title>
          <span class="headline">Prazos e Detalhes</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="fileForm" v-model="valid" lazy-validation>
                  <p class="body-1">
                    Inclua uma imagem, que será utilizada na apresentação ao
                    munícipe, para ilustrar a ideia do projeto.
                  </p>
                  <div v-if="projectIllustration">
                    <v-file-input
                      class="mt-2"
                      color="secondary"
                      outlined
                      show-size
                      display:none
                      disabled
                      placeholder="Caso queira alterar a imagem, primeiro exclua a anterior"
                    ></v-file-input>
                  </div>
                  <div v-else>
                    <div v-if="!currentHardwareFile">
                      <v-file-input
                        class="mt-2"
                        color="secondary"
                        outlined
                        show-size
                        display:none
                        @change="selectIllustrationFile"
                        :value="illustrationFile"
                        :rules="sizeRule"
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Clique aqui para anexar um arquivo de até 10MB"
                      ></v-file-input>
                    </div>
                    <div v-else>
                      <v-file-input
                        clear-icon
                        disabled
                        color="secondary"
                        outlined
                        show-size
                        placeholder="Envie o arquivo especificação antes de selecionar este arquivo"
                      ></v-file-input>
                    </div>
                  </div>
                  <v-chip
                    class="mb-6 ml-8"
                    close
                    color="default"
                    :text-color="textFileColor"
                    @click="download(projectIllustration)"
                    @click:close="getFileToDelete(projectIllustration.id)"
                    v-if="projectIllustration"
                  >
                    <v-icon left>
                      mdi-download-circle
                    </v-icon>
                    <span class="text-truncate" style="max-width: 250px;">
                      {{ projectIllustration && projectIllustration.file }}
                    </span>
                  </v-chip>
                  <div class="d-flex mb-12" v-if="projectIllustration || !currentIllustrationFile">
                  <v-btn class="ml-auto" color="secondary" disabled>
                      <v-icon left>
                        mdi-upload
                      </v-icon>
                      Enviar Arquivo
                    </v-btn>
                  </div>
                  <div class="d-flex mb-12" v-else>
                    <v-btn class="ml-auto" color="secondary" @click="handleFirstFile">
                      <v-icon left>
                        mdi-upload
                      </v-icon>
                      Enviar Arquivo
                    </v-btn>
                  </div>
                  <p class="body-1">
                    Em caso de compra de equipamentos, há especificação técnica
                    dos mesmos? Se sim, anexar especificação na devolutiva.
                  </p>
                  <div v-if="projectHardware">
                    <v-file-input
                      color="secondary"
                      outlined
                      show-size
                      disabled
                      placeholder="Caso queira alterar a especificação, primeiro exclua a anterior"
                    ></v-file-input>
                  </div>
                  <div v-else>
                    <div v-if="!currentIllustrationFile">
                      <v-file-input
                        color="secondary"
                        outlined
                        show-size
                        @change="selectHardwareFile"
                        :value="hardwareFile"
                        :rules="sizeRule"
                        accept=".pdf"
                        placeholder="Clique aqui para anexar um arquivo de até 10MB"
                      ></v-file-input>
                    </div>
                    <div v-else>
                      <v-file-input
                      clear-icon
                      disabled
                      color="secondary"
                      outlined
                      show-size
                      placeholder="Envie o arquivo imagem antes de selecionar este arquivo"
                      ></v-file-input>
                    </div>
                  </div>
                  <v-chip
                    class="mb-6 ml-8"
                    close
                    color="default"
                    :text-color="textFileColor"
                    @click="download(projectHardware)"
                    @click:close="getFileToDelete(projectHardware.id)"
                    v-if="projectHardware"
                  >
                    <v-icon left>
                      mdi-download-circle
                    </v-icon>
                    <span class="text-truncate" style="max-width: 250px;">
                      {{ projectHardware && projectHardware.file }}
                    </span>
                  </v-chip>
                  <div class="mt-6 d-flex" v-if="projectHardware || !currentHardwareFile">
                    <v-btn class="ml-auto" color="secondary" disabled>
                      <v-icon left>
                        mdi-upload
                      </v-icon>
                      Enviar Arquivo
                    </v-btn>
                  </div>
                  <div class="mt-6 d-flex" v-else>
                    <v-btn class="ml-auto" color="secondary" @click="handleSecondFile">
                      <v-icon left>
                        mdi-upload
                      </v-icon>
                      Enviar Arquivo
                    </v-btn>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <v-container class="pa-0">
      <v-row justify="space-between">
        <v-col class="col-button">
          <v-btn text color="default" @click="previous">
            Anterior
          </v-btn>
        </v-col>
        <v-col class="col-button">
          <v-btn class="ml-auto" color="secondary" @click="finish">
            Finalizar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <dialog-delete-file
      :dialogChild="dialogDelete"
      @closeChild="closeDelete"
      @confirmChild="deleteFileConfirm"
    />
    <dialog-upload-first-save
      :dialogChild="dialogFirstSave"
      @closeChild="closeFirstSave"
      @confirmChild="firstSaveConfirm"
    />
  </div>
</template>

<script>
import {
  uploadService,
  downloadService,
  deleteService,
} from '@/services/files';
import getErrorMessage from '@/utils/getErrorMessage';
import DialogDeleteFile from './dialog-delete-file';
import DialogUploadFirstSave from './dialog-upload-first-save';

export default {
  name: 'file-handler',

  components: {
    DialogDeleteFile,
    DialogUploadFirstSave,
  },

  data: () => ({
    valid: true,
    currentConstructionFile: undefined,
    currentHardwareFile: undefined,
    currentIllustrationFile: undefined,
    sizeRule: [v => !v || v.size < 10000000 || 'Tamanho máximo de 10MB'],
    project: {},
    fieldNameToUpload: '',
    dialogFirstSave: false,
    dialogDelete: false,
    fileToDelete: null,
  }),

  computed: {
    illustrationFile() {
      return this.currentIllustrationFile;
    },
    constructionFile() {
      return this.currentConstructionFile;
    },
    hardwareFile() {
      return this.currentHardwareFile;
    },
    projectIllustration() {
      return this.project.files.find(file => file.type === 'illustration');
    },
    projectConstruction() {
      return this.project.files.find(
        file => file.type === 'constructionProject',
      );
    },
    projectHardware() {
      return this.project.files.find(file => file.type === 'hardwareEspec');
    },
    textFileColor() {
      return this.$vuetify.theme.dark ? '#505050' : '#f1f1f1';
    },
  },

  methods: {
    selectIllustrationFile(file) {
      this.currentIllustrationFile = file;
    },
    selectConstructionFile(file) {
      this.currentConstructionFile = file;
    },
    selectHardwareFile(file) {
      this.currentHardwareFile = file;
    },
    getFileToUpload(fieldName) {
      switch (fieldName) {
        case 'illustration':
          return this.currentIllustrationFile;
        case 'constructionProject':
          return this.currentConstructionFile;
        case 'hardwareEspec':
          return this.currentHardwareFile;

        default:
          return undefined;
      }
    },
    getFileToDelete(id) {
      this.fileToDelete = id;
      this.dialogDelete = true;
    },
    displayFile(data) {
      this.project.files.push(data);
    },
    hideFile(id) {
      const otherFiles = this.project.files.filter(file => file.id !== id);
      this.project.files = [...otherFiles];
      this.fileToDelete = null;
    },
    async upload(fieldName) {
      if (!this.project.id) {
        this.dialogFirstSave = true;
        return;
      }
      const fileToUpload = this.getFileToUpload(fieldName);

      try {
        this.$store.dispatch('loading', true);

        if (fileToUpload === undefined) {
          throw new Error('Clique no campo para escolher um arquivo');
        }

        const metadata = {
          projectId: this.project.id,
          fieldName,
        };
        const response = await uploadService(fileToUpload, metadata);
        this.displayFile(response.data.file);

        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: 'Arquivo enviado com sucesso',
        });
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
        this.reset();
      }
    },
    async download(file) {
      try {
        this.$store.dispatch('loading', true);

        await downloadService(file.id, file.file);

        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: 'Arquivo baixado com sucesso',
        });
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async delete(id) {
      try {
        this.$store.dispatch('loading', true);

        await deleteService(id);
        this.hideFile(id);

        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: 'Arquivo apagado com sucesso',
        });
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteFileConfirm() {
      this.closeDelete();
      this.delete(this.fileToDelete);
    },
    closeFirstSave() {
      this.dialogFirstSave = false;
    },
    firstSaveConfirm() {
      this.closeFirstSave();
      const payload = { project: this.project, next: false };
      this.$emit('saveProject', payload);
    },
    validate() {
      return this.$refs.fileForm.validate();
    },
    checkAllFilesSent() {
      const allFilesSent =
        !this.currentIllustrationFile &&
        !this.currentConstructionFile &&
        !this.currentHardwareFile;

      if (!allFilesSent) {
        this.$store.dispatch('toggleToastAlert', {
          message:
            'Você tem arquivos não enviados. Clique no botão \'ENVIAR ARQUIVO\' correspondente.',
        });
      }

      return allFilesSent;
    },
    reset() {
      this.$refs.fileForm.reset();
      this.fieldNameToUpload = '';
    },
    resetValidation() {
      this.$refs.fileForm.resetValidation();
    },
    finish() {
      if (this.validate() && this.checkAllFilesSent()) {
        this.$store.dispatch('editProject', this.project);
        this.$emit('finish');
      }
    },
    previous() {
      this.$emit('previous');
    },
    async handleFirstFile() {
      await this.upload('illustration');
    },
    async handleSecondFile() {
      await this.upload('hardwareEspec');
    },
  },
  created() {
    this.project = this.$store.state.project;
  },
};
</script>

<style scoped>
form p {
  margin-bottom: 8px;
}
.col-button {
  flex-grow: unset;
  padding: 0 16px 16px;
}
</style>
